import React, { Component } from 'react';
import { Motion, spring } from 'react-motion';
import './style.scss';
import { connect } from 'react-redux';

class RoundChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    const {
      title, percent, color, width = '164px', height = '164px', percentStyle, titleStyle, titleBottom, isDarkTheme,
    } = this.props;
    const textColor = color === 'orange' ? '#F5A623' : '#45A4DB';
    return (
      <Motion
        defaultStyle={{ percent: 0 }}
        style={{
          percent: spring(percent, {
            stiffness: 159,
            damping: 34,
            precision: 1,
          }),
        }}
      >
        {interpolated => (
          <div
            className="donutContainer"
            style={{ width, height }}
          >
            <svg width="100%" height="100%" viewBox="0 0 34 34" className="donut">
              <defs>
                <linearGradient id="blue" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="20%" stopColor="#236FB6" />
                  <stop offset="80%" stopColor="#43A0D8" />
                </linearGradient>
                <linearGradient id="orange" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="20%" stopColor="#F76B1C" />
                  <stop offset="80%" stopColor="#FAD961" />
                </linearGradient>
              </defs>
              <circle className="donut-hole" cx="17" cy="17" r="15.91549430918952" fill="transparent" />
              <circle className="donut-ring" cx="17" cy="17" r="15.91549430918952" fill="transparent" stroke={isDarkTheme ? '#181e26' : '#F1F2F2'} strokeWidth={isDarkTheme ? '1.2' : '2.5'} />
              <circle
                stroke={`url(#${color})`}
                cx="17"
                cy="17"
                r="15.91549430918952"
                fill="transparent"
                strokeLinecap={isDarkTheme ? 'butt' : 'round'}
                strokeWidth={isDarkTheme ? '1.2' : '1.8'}
                strokeDasharray={`${interpolated.percent} ${100 - interpolated.percent}`}
                strokeDashoffset="25"
              />
            </svg>
            <div className="infoContainer">
              {!titleBottom && <h3 style={{ ...titleStyle }}>{title}</h3>}
              <p style={{ color: textColor, ...percentStyle }}>
                {Math.ceil(interpolated.percent)}%
              </p>
              {titleBottom && <h3 style={{ ...titleStyle }}>{title}</h3>}
            </div>
          </div>
        )}
      </Motion>
    );
  }
}
const mapStateToProps = state => ({
  isDarkTheme: state.app.isDarkTheme,
});

const RoundChartConnected = connect(mapStateToProps)(RoundChart);

export { RoundChartConnected as RoundChart };



// WEBPACK FOOTER //
// ./src/view/common/RoundChart/index.jsx